import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(routes)/events/_components/EventCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(routes)/events/_components/EventPageNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
